import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import emailjs from '@emailjs/browser';
import './Contact.css';

export default function Contact() {
  const initialValues = {
    name: '',
    email: '',
    message: '',
  };

  const validationSchema = Yup.object({
    name: Yup.string().required('Nimi vaaditaan'),
    email: Yup.string().email('Virheellinen sähköposti').required('Sähköposti vaaditaan'),
    message: Yup.string().required('Viesti vaaditaan'),
  });

  const onSubmit = (values, { resetForm }) => {
    emailjs.send(
      'service_8net8to',     // esim. service_xxx
      'template_nwqe99h',    // esim. template_yyy
      values,
      'RS8VnSAJDssRe-POI'      // esim. Abc1234
    )
    .then(() => {
      alert('Viesti lähetetty onnistuneesti!');
      resetForm();
    })
    .catch((error) => {
      console.error('Virhe lähetyksessä:', error);
      alert('Virhe lähetyksessä, yritä uudelleen.');
    });
  };

  return (
    <section id="contact" className="section">
      <h2 id="contactheader">Ota meihin yhteyttä!</h2>
      <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
        <Form className="contact-form">
          <div>
            <label htmlFor="name">Name</label>
            <Field type="text" id="name" name="name" />
            <ErrorMessage name="name" component="div" className="error" />
          </div>

          <div>
            <label htmlFor="email">Email</label>
            <Field type="email" id="email" name="email" />
            <ErrorMessage name="email" component="div" className="error" />
          </div>

          <div>
            <label htmlFor="message">Type your  message here...</label>
            <Field as="textarea" id="message" name="message" />
            <ErrorMessage name="message" component="div" className="error" />
          </div>

          <button type="submit">Submit</button>
        </Form>
      </Formik>
    </section>
  );
}
